import React, { useEffect, useRef, useState, memo } from "react";

type LazyRenderProps = {
  children: React.ReactNode;
  offset?: number | string; // 距离视口底部的触发距离，默认200px
  onInitEvent?: Function | null; // 懒加载出来的组件 执行初始化事件 (一般用于埋点)
};

const LazyRender: React.FC<LazyRenderProps> = memo(
  ({ children, offset = "10px", onInitEvent }) => {
    const [isVisible, setIsVisible] = useState(false);
    const targetRef = useRef<HTMLDivElement>(null);
    const childrenRef = useRef<any>();
    const [isDone, setIsDone] = useState(false);

    useEffect(() => {
      if (!window.IntersectionObserver) {
        setIsVisible(true); // 如果不支持 IntersectionObserver，直接显示内容
        return;
      }

      // 确保 offset 是字符串类型
      const offsetStr = typeof offset === "number" ? `${offset}px` : offset;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target); // 停止观察
          }
        },
        {
          rootMargin: `0px 0px ${offsetStr} 0px`, // 使用 offset 扩展视口范围
        },
      );

      const current = targetRef.current;
      if (current) observer.observe(current);

      return () => {
        if (current) observer.unobserve(current); // 清理观察器
      };
    }, [offset]);
    useEffect(() => {
      if (isVisible) {
        console.log("%c Line:44 🥪 isVisible", "color:#4fff4B", isVisible);
        onInitEvent && onInitEvent();
        setTimeout(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (childrenRef.current) {
                console.log("组件已加载完成");
                setIsDone(true);
              }
            });
          });
        }, 300);
      }
    }, [isVisible]);

    // 如果已经可见，直接渲染 children
    if (isVisible) {
      return (
        <div ref={childrenRef} style={{ height: isDone ? "auto" : "100vh" }}>
          {children}
        </div>
      );
    }

    // 如果不可见，渲染一个占位元素
    return (
      <div
        ref={targetRef}
        style={{
          position: "relative",
          height: "100vh", // 设置占位元素的高度为 offset
          overflow: "hidden", // 防止子元素溢出vb
          marginTop: "10px",
        }}
      />
    );
  },
);

export default LazyRender;
